import { handleRequest } from '@/utils';

export const next = async (params: any) => {
  return handleRequest('postMessage', params);
};
